import {
  AutocompleteArrayInput,
  BooleanInput,
  Create,
  email,
  ListButton,
  number,
  NumberInput,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { SimpleBoxLoader } from "@/components/loader";
import { MODULE_NAMES } from "@/constants";
import { ReferenceAutoCompleteArrayInput } from "@/inputs/ReferenceAutoCompleteArrayInput";
import { useRadiusVpnServers } from "@/modules/radiusVpnServers";

import { ClientAppCopyVpn } from "./ClientAppCopyVpn";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const ClientAppCreate = () => {
  const {
    data: { radiusVpnServersChoices } = {},
    isLoading: isRadiusVpnServersLoading,
  } = useRadiusVpnServers();

  if (isRadiusVpnServersLoading) {
    return <SimpleBoxLoader />;
  }

  return (
    <Create actions={<CreateActions />} redirect="list" title="Client App">
      <SimpleForm toolbar={<CreateToolbar />}>
        <TextInput source="title" validate={required()} />
        <TextInput source="name" validate={required()} />
        <TextInput source="secret" validate={required()} />
        <TextInput source="email" validate={[required(), email()]} />
        <NumberInput
          label="Device Type Id"
          source="deviceTypeId"
          validate={[number(), required()]}
        />
        <AutocompleteArrayInput
          source="vpnServers"
          label="VPN Servers"
          choices={radiusVpnServersChoices || []}
          disableCloseOnSelect
        />
        <ClientAppCopyVpn />
        <ReferenceAutoCompleteArrayInput
          module={MODULE_NAMES.LANDINGS}
          source="allowedLandings"
          optionText="appLandingId"
          optionValue="@id"
          disableCloseOnSelect
        />
        <BooleanInput source="isCampaignDriven" label="Is Campaign Driven" />
        <TextInput source="diKey" label="Di Key" validate={required()} />
        <TextInput source="domain" validate={required()} />
      </SimpleForm>
    </Create>
  );
};
